import { jsPDF } from 'jspdf';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import frenchlan from '../../../french.json';
import malayalamlan from '../../../malayalam.json';
import './NotoSansDevanagari'; 

const DownloadQAPDF = (jsonData, batchNo, QAdata) => {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)
		? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`))
		: 2;

	const langdata =
		langid === 1 ? englan :
			langid === 2 ? englan :
				langid === 3 ? frenchlan :
					langid === 4 ? germanlan :
						langid === 6 ? malayalamlan :
							englan;

	const generatePDF = () => {
		if (!jsonData || jsonData.length === 0) return;

		const outgoingUser = QAdata?.outgoingUser || '—';
		const incomingUser = QAdata?.incomingUser || '—';
		const shiftDateTime = QAdata?.shiftDateTime || '—';

		const pdf = new jsPDF();
		pdf.setFont('NotoSansDevanagari', 'normal');

		let yPosition = 20;
		const pageHeight = pdf.internal.pageSize.height;

		// Title (CENTERED)
		pdf.setFontSize(18);
		pdf.text(
			langdata?.ShiftReport || 'Shift Report' ,
			pdf.internal.pageSize.width / 2,
			yPosition,
			{ align: 'center' }
		);

		yPosition += 10;
		pdf.setFontSize(11);

		// LEFT SIDE (Outgoing & Incoming)
		pdf.text(`Outgoing User: ${outgoingUser}`, 10, yPosition);
		yPosition += 7;
		pdf.text(`Incoming User: ${incomingUser}`, 10, yPosition);

		// RIGHT SIDE (Shift Date Time)
		pdf.text(
			`Shift Date Time: ${shiftDateTime}`,
			pdf.internal.pageSize.width - 10,
			yPosition - 7,
			{ align: 'right' }
		);

		yPosition += 12;
		// yPosition += 15;
		pdf.setFontSize(12);

		let count = 1;

		jsonData.forEach((item) => {
			const question = item?.shiftquestions?.text || '—';
			const answer = item?.text || '—';

			if (yPosition + 40 > pageHeight) {
				pdf.addPage();
				yPosition = 20;
			}

			const questionLines = pdf.splitTextToSize(
				`Q${count}. ${question}`,
				180
			);
			pdf.text(questionLines, 10, yPosition);
			yPosition += questionLines.length * 7 + 5;
			
			// yPosition += 10;

			const answerLines = pdf.splitTextToSize(answer, 180);

			pdf.text('Ans:', 10, yPosition);
			yPosition += 7;

			pdf.text(answerLines, 15, yPosition); // indent answer
			yPosition += answerLines.length * 7 + 10;

			count++;
		});

		pdf.save(`Shift-Report-QA-${batchNo + 1}.pdf`);
	};

	generatePDF();
	return null;
};

export default DownloadQAPDF;
